import { render, staticRenderFns } from "./Legend.vue?vue&type=template&id=214f1ee8&scoped=true&"
import script from "./Legend.vue?vue&type=script&lang=js&"
export * from "./Legend.vue?vue&type=script&lang=js&"
import style0 from "./Legend.vue?vue&type=style&index=0&id=214f1ee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214f1ee8",
  null
  
)

export default component.exports